import SkeletonModule from './skeleton.module'

export default SkeletonModule
